import { CatalogItem } from '../../../../@types/catalog-item';
import BulletList from '../../shared/bullet-list';

function entitlementDesc(entitlement: CatalogItem['entitlements'][0]) {
  const { type, configuration, description, name } = entitlement;
  if (type !== 'tutoring_hours') return description || name;
  return (
    <>
      <strong>{configuration.number_of_hours}</strong> {description || name}
    </>
  );
}

function CartItemFeatures({ item }: { item: CatalogItem }) {
  return (
    <>
      {item.entitlements && (
        <BulletList>
          {item.entitlements?.slice(0, 2).map((entitlement, index) => (
            <li key={index}>{entitlementDesc(entitlement)}</li>
          ))}
        </BulletList>
      )}
    </>
  );
}

export default CartItemFeatures;
